import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./List";
import Add from "./Add";
import Summary from "./Summary";

function Employee({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/add`} component={Add} />
      <Route path={`${path}/:id/summary`} component={Summary} />
      <Route path={`${path}/:id/edit`} component={Summary} />
    </Switch>
  );
}

export { Employee };
